export default __webpack_public_path__ + "img/cacLogoDark.3dd5de.svg";